import type {
  DoNotBuyOriginType,
  DoNotBuyStatus,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createDoNotBuyMutationAtom = createMutationAtomFactory(
  'settings.doNotBuyEntryCreate',
  (params: {
    accountId: string;
    facilityId?: string;
    reason: string;
    status: DoNotBuyStatus;
    originType: DoNotBuyOriginType;
    effectiveFrom: string;
    effectiveTo?: string;
    addedByUserId: string;
    notes?: string;
  }) => ({
    complianceDoNotBuyEntryCreate: {
      __args: {
        input: {
          accountId: params.accountId,
          facilityId: params.facilityId,
          reason: params.reason,
          status: params.status,
          originType: params.originType,
          effectiveFrom: params.effectiveFrom,
          effectiveTo: params.effectiveTo,
          addedByUserId: params.addedByUserId,
          notes: params.notes,
        },
      },
      id: true,
    },
  }),
);
